import React, { useEffect } from 'react'

import HR from 'components/HR'
import TrustPilotWidget from 'components/TrustPilot/Widget'

import Breadcrumb from '../components/Breadcrumb'
import Header from '../components/header'
import PaginationHitsPerPageLayout from './PaginationHitsPerPage'
import ArtworksList from '../components/artworks/List'
import { FeatureLayout, MainContent } from '../components/styles'
import AppConnector, { ConnectorProps as AppProps } from '../connectors/App'
import { setAlgoliaQueryIDInLocalStorage } from 'lib/algolia/v2/helpers'
import { addStoreLocaleByCookie } from 'lib/storeLocale/client'
import SearchArtworks from 'apps/private/search/algolia/components/SearchArtworks'

const Component = ({ queryID }: AppProps): React.ReactElement<React.ComponentProps<any>, any> => {
  useEffect(() => {
    // store ALGOLIA_QUERY_ID in local storage
    setAlgoliaQueryIDInLocalStorage(queryID)
  })

  const navigateToSearch = (value): void => {
    const location = addStoreLocaleByCookie(`/search?query=${value}`)
    window.location.href = location
  }

  return (
    <FeatureLayout>
      <Header />

      <SearchArtworks updateSearch={navigateToSearch} showClearButton />

      <MainContent>
        <ArtworksList />
      </MainContent>

      <HR />

      <PaginationHitsPerPageLayout />

      <TrustPilotWidget />

      <HR />

      <Breadcrumb />
    </FeatureLayout>
  )
}

export default AppConnector(Component)
